import { render, staticRenderFns } from "./UploadProductFileForm.vue?vue&type=template&id=39780853&scoped=true&"
import script from "./UploadProductFileForm.vue?vue&type=script&lang=js&"
export * from "./UploadProductFileForm.vue?vue&type=script&lang=js&"
import style0 from "./UploadProductFileForm.vue?vue&type=style&index=0&id=39780853&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39780853",
  null
  
)

export default component.exports